
import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'RequirementApplicationReview',
  components: {
    Icon
  }
})
export default class RequirementApplicationReview extends Vue {
  @Prop({ default: '' }) requirementAlias!: string
  @Prop({ default: '' }) requirementName!: string[]
  @Prop({}) denoteIcon!: string
  @Prop({}) previewIcon!: string
  @Prop({ default: false }) isOptional!: boolean
}
